var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuperBuiltupArea = function SvgSuperBuiltupArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#super_builtup_area_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7.763 25.413V2.109c0-.776-.63-1.406-1.406-1.406H2.109c-.776 0-1.406.63-1.406 1.406v31.782c0 .776.63 1.406 1.406 1.406h31.781999999999996c.776 0 1.406-.63 1.406-1.406v-4.248c0-.777-.63-1.406-1.406-1.406H10.587M31.768 28.238v2.56M28.236 28.238v3.53M24.707 28.238v2.56M21.178 28.238v3.53M17.647 28.238v2.56M14.117 28.238v3.53M4.94 4.234h2.823M5.906 7.762h1.857M4.94 11.293h2.823M5.906 14.824h1.857M4.94 18.352h2.823M5.906 21.883h1.857"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M.703 25.414h8.478c.776 0 1.406.63 1.406 1.406v8.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M29.53 20.473v4.942H19.06v-4.942H29.53M35.297 15.527v4.942H23.766v-4.942h11.530999999999999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M29.53 10.586v4.942H19.06v-4.942H29.53M35.296 5.645v4.941h-8.472V5.645h8.472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M29.531.703v4.942h-4.824V.703z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M24.707 5.645V.703h10.59v24.71H19.059"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.825 5.645h-4.942v4.941M19.059 15.528v-4.942h7.766M26.824 5.645h8.472M35.296 10.586h-8.472M23.766 15.527h11.530999999999999M35.297 20.473H29.53M23.766 20.473h5.765M23.765 20.473H19.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.234 20.469v-4.942h7.531M19.058 25.415H13.41v-4.942h5.648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M8.467 33.177v-5.642H2.825v5.642z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "super_builtup_area_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgSuperBuiltupArea;